import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Lightbulb, MessageCircleHeart, HeartHandshake, Heart } from 'lucide-react';
export function PackContents() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const contents = [{
    icon: <BookOpen className="w-6 h-6 text-white" data-id="element-62" />,
    title: 'Guía Principal: Del Silencio a la Confianza',
    description: 'El manual paso a paso de 7 días que te dice qué hacer desde que se levanta hasta que se acuesta para bajar sus defensas.',
    color: 'bg-navy'
  }, {
    icon: <Lightbulb className="w-6 h-6 text-white" data-id="element-63" />,
    title: 'Protocolo de Validación Positiva (Día 3)',
    description: 'Aprendé el mecanismo para reconocer sus logros por pequeños que sean, logrando que baje su guardia automáticamente.',
    color: 'bg-amber'
  }, {
    icon: <MessageCircleHeart className="w-6 h-6 text-white" data-id="element-64" />,
    title: 'Mecanismo de Escucha Activa y Empatía (Día 1/2)',
    description: 'Técnicas validadas para entrar a su mundo sin que parezca un interrogatorio policial.',
    color: 'bg-terracotta'
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-white" data-id="element-65" />,
    title: 'Módulo de Afecto sin Expectativas',
    description: 'Cómo acercarte físicamente sin que se sienta invadido o "asfixiado". Un afecto sutil y seguro.',
    color: 'bg-rose'
  }, {
    icon: <Heart className="w-6 h-6 text-white" data-id="element-66" />,
    title: 'Módulo de Amor Incondicional',
    description: 'Herramientas concretas para reafirmar tu amor, incluso en los momentos más difíciles de rebeldía.',
    color: 'bg-gold'
  }];
  return <section className="bg-white py-20 px-4 md:px-8 lg:px-16" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-70">
            QUÉ INCLUYE EL PACK RECONEXIÓN
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-71">
            Lo que necesitás para que el hogar vuelva a ser un refugio en piloto
            automático:
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-72">
          {contents.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col sm:flex-row items-start sm:items-center bg-cream rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-73">
              <div className={`${item.color} w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mb-4 sm:mb-0 sm:mr-6 shadow-sm`} data-id="element-74">
                {item.icon}
              </div>
              <div data-id="element-75">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-76">
                  {item.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-77">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}